import { useRef } from "react"

import { getDocument } from "shared/lib/getDocument"

import { useEvent } from "./useEvent"
import { useValueRef } from "./useValueRef"

const ROOT_LAYER = "ROOT"

export function useFocusRestore() {
  const focusedElementRef = useValueRef(getDocument()?.activeElement)
  const focusedElementByLayer = useRef<Record<string, string | null>>({})

  const saveFocus = useEvent(
    (id: string | null | undefined, layer: string | null) => {
      if (id) {
        focusedElementByLayer.current[layer || ROOT_LAYER] = id
      } else if (focusedElementRef.current) {
        focusedElementByLayer.current[layer || ROOT_LAYER] =
          focusedElementRef.current.id
      }
    }
  )

  const clearLayer = useEvent((layer: string | null) => {
    delete focusedElementByLayer.current[layer || ROOT_LAYER]
  })

  const restoreFocus = useEvent((layer: string | null) => {
    const id = focusedElementByLayer.current[layer || ROOT_LAYER]
    clearLayer(layer)
    if (id) {
      getDocument()?.getElementById(id)?.focus()
    }
  })

  return { saveFocus, restoreFocus, clearLayer }
}
